// extracted by mini-css-extract-plugin
export default {"dragging":"DraggableItem_dragging__wIwmm","draggable":"DraggableItem_draggable__7WPFc","undraggable":"DraggableItem_undraggable__Yro+s"};